import React from 'react'

interface Props {
  children: React.ReactNode
  className?: string
}
export const FormBody: React.FC<Props> = ({children, className}) => {
  return <div className={`card-body ${className ?? 'px-9'}`}>{children}</div>
}
